import { ActivatedRoute, Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import {
    AdvisoryModel,
    GetAppropriatenessClientUseCase,
    GetClientUseCase,
    GetContractUseCase,
    GetTestResultsUseCase,
    GetTestUseCase,
    UpdateTestUseCase,
} from '../../../../core';
import { Id, Test } from '../../../domain/data';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RepeatTestPage } from '../repeat-test.page';
import { TestQuestionPage } from '../../test/question/test-question.page';

@Component({
    templateUrl: './repeat-test-question.page.html',
    styleUrls: ['../../test/question/test-question.page.scss'],
})
export class RepeatTestQuestionPage extends TestQuestionPage {
    constructor(
        parentEvents: ParentEvents,
        dialog: MatDialog,
        getAppropriatenessClientUseCase: GetAppropriatenessClientUseCase,
        getContractUseCase: GetContractUseCase,
        getTestUseCase: GetTestUseCase,
        getTestResults: GetTestResultsUseCase,
        route: ActivatedRoute,
        router: Router,
        repeatTestPage: RepeatTestPage,
        updateTestUseCase: UpdateTestUseCase,
        private localStorage: LocalStorage,
        private getClientUseCase: GetClientUseCase
    ) {
        super(
            parentEvents,
            dialog,
            getAppropriatenessClientUseCase,
            getContractUseCase,
            getTestUseCase,
            getTestResults,
            route,
            router,
            repeatTestPage,
            updateTestUseCase
        );
        this.questionPage = MainRoutes.REPEAT_TEST_QUESTION;
        this.resultPage = MainRoutes.REPEAT_TEST_RESULT;
    }

    protected getTest() {
        if (this.localStorage.clientId && this.localStorage.clientCode) {
            this.clientId = Id.fromString(this.localStorage.clientId);

            if (this.step === 0) {
                this.testPage.hideBackButton();
            } else {
                this.testPage.showBackButton();
            }

            this.getClientUseCase.bind({ code: Id.fromString(this.localStorage.clientCode) }).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.appropriatenessClient = transaction.data;

                    const advisoryModel = !this.appropriatenessClient.profileId ? AdvisoryModel.C : AdvisoryModel.A;

                    this.getTestUseCase.bind({ clientId: this.clientId, advisoryModel }).subscribe((testTransaction) => {
                        if (testTransaction.isSuccess) {
                            this.test = testTransaction.data as Test;
                            this.isSuitability = advisoryModel !== AdvisoryModel.C;

                            if (this.isSuitability) {
                                this.totalSteps = this.test.questions.length;
                                this.resultPage = MainRoutes.REPEAT_TEST_RESULT + '?suitability=1';
                            } else {
                                this.onNext();
                            }
                        } else if (!testTransaction.isAuthError) {
                            this.dialog.open(ErrorDialog, {
                                data: { text: testTransaction.error },
                            });
                        }
                    });
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
        } else {
            this.parentEvents.cancel();
        }
    }

    protected updateTest() {
        this.updateTestUseCase
            .bind({
                clientId: this.clientId,
                test: this.test,
                requiredSignature: true,
            })
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.router.navigateByUrl(this.resultPage);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
    }

    onCancel() {
        this.parentEvents.cancel();
    }
}
